export default {
  getDeviceByID: (state) => (inputValue) => {
    return state.devices.filter(device => {
      var deviceNameResult = null
      var phoneNumberResult = null
      if (device.deviceName !== null) {
        deviceNameResult = device.deviceName.match(inputValue)
      }
      if (device.phoneNumber2 !== null) {
        phoneNumberResult = device.phoneNumber2.match(inputValue)
      }
      if (deviceNameResult !== null || phoneNumberResult !== null) {
        var result = device.deviceName + device.phoneNumber2
        return result.match(inputValue)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/deviceModules/getters.js